import * as React from "react";
import { EmailUse } from "./admin-gql";
import { getEmailUseDisplayNames } from "./displayNames";
export var SelectEmailUse = function (props) {
    return (React.createElement("select", { className: "form-control", disabled: props.disabled || props.readonly, value: props.use, onChange: function (ev) { return props.onChange(ev.target.value); } }, Object.keys(EmailUse).map(function (x) { return (React.createElement("option", { value: x, key: x }, getEmailUseDisplayNames(x) || x)); })));
};
//# sourceMappingURL=SelectEmailUse.js.map